import React, { useState, useRef, useEffect } from 'react'
import { Link } from "react-router-dom"
import { useLocation } from 'react-router-dom'
import { ArrowDown, ArrowUp } from '../assets/icons';

const Sidebarimg = 'https://fnicdn.blob.core.windows.net/regionh/region%20h.png';
const Headerimg = 'https://fnicdn.blob.core.windows.net/regionh/header2.jpg';

export default function Navbar() {
    const location = useLocation();
    const { pathname } = location;
    const splitLocation = pathname.split("/");

    return (
        <div style={{ backgroundColor: '#1F497D' }} className='mb-3'>
            <div className='container d-none d-lg-block'>
                <div className='row'>
                    <div className='col-2 px-0'>
                        <a href="/" className="d-none d-lg-block align-items-center text-decoration-none">
                            <img src={Sidebarimg} className="w-100" alt="Region H logo" />
                        </a>
                    </div>
                    {/*
                        <div className='col-10 px-0'>
                        <img src={Headerimg} className="d-block" style={{ objectFit: "cover" }} alt="Header" />
                    </div>
                    */}
                </div>
            </div>
            <div className='row d-lg-none mb-2 d-flex flex-shrink-0' style={{ backgroundColor: '#1F497D' }}>
                <div className='col-5 ms-2'>
                    <a href="/" className="d-flex align-items-center text-decoration-none">
                        <img src={Sidebarimg} className="w-100" alt="Region H logo" />
                    </a>
                </div>
                <div className='col text-end me-3 mt-3'>
                    <button
                        className="navbar-toggler collapsed navbar-dark"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarCollapse"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>
                </div>
            </div>
            <div style={{ backgroundColor: '#ebf1fa' }}>
                <div className='container py-1'>
                    <div className="d-none d-lg-block">
                        <NavLinks splitLocation={splitLocation} />
                    </div>
                    <div className="collapse navbar-collapse d-lg-none" id="navbarCollapse">
                        <NavLinks splitLocation={splitLocation} mobile />
                    </div>
                </div>
            </div>
        </div>
    )
}

function NavLinks({ splitLocation, mobile = false }) {
    const [openDropdowns, setOpenDropdowns] = useState({
        aboutus: false,
        meetings: false,
        downloads: false,
    });

    const refs = {
        aboutus: useRef(null),
        meetings: useRef(null),
        downloads: useRef(null),
    };

    useEffect(() => {
        if (mobile) return;
        const handleClickOutside = (e) => {
            const clickedOutsideAll = Object.values(refs).every(
                ref => ref.current && !ref.current.contains(e.target)
            );
            if (clickedOutsideAll) {
                setOpenDropdowns({ aboutus: false, meetings: false, downloads: false });
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [mobile]);

    const toggleDropdown = (e, key) => {
        e.preventDefault();
        setOpenDropdowns(prev => {
            // On desktop, close others when opening a new one
            if (!mobile) {
                const allClosed = Object.fromEntries(Object.keys(prev).map(k => [k, false]));
                return { ...allClosed, [key]: !prev[key] };
            }
            return { ...prev, [key]: !prev[key] };
        });
    };

    const dropdownMenuStyle = {
        position: 'absolute',
        top: '100%',
        left: 0,
        zIndex: 1000,
        backgroundColor: '#fff',
        border: '1px solid rgba(0,0,0,.15)',
        borderRadius: '0.375rem',
        boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
        minWidth: '200px',
        padding: '0.5rem 0',
    };

    const dropdownItemStyle = (active) => ({
        display: 'block',
        padding: '0.4rem 1rem',
        color: active ? '#fff' : '#333',
        backgroundColor: active ? '#1F497D' : 'transparent',
        borderRadius: '0.25rem',
        textDecoration: 'none',
        fontSize: '0.9rem',
        whiteSpace: 'nowrap',
    });

    return (
        <ul className="nav nav-pills mb-auto text-start mt-2" style={{ flexWrap: 'wrap' }}>

            <li className="nav-item mx-2 mb-1">
                <Link className={`nav-link ${splitLocation[1] === "" ? "active" : ""}`} to="/">
                    Home
                </Link>
            </li>

            <li className="nav-item mx-2 mb-1">
                <Link className={`nav-link ${splitLocation[1] === "AboutRegionPlan" ? "active" : ""}`} to="/AboutRegionPlan">
                    About Regional Planning
                </Link>
            </li>

            {/* About Us dropdown */}
            <li
                className="nav-item mx-2 mb-1"
                style={{ position: 'relative' }}
                ref={refs.aboutus}
            >
                <a
                    href="#"
                    className={`nav-link d-flex justify-content-between align-items-center gap-2 ${['AboutUs', 'PlanningArea', 'PlanningGroup', 'CommitteeAssignments'].includes(splitLocation[1]) ? "active" : ""}`}
                    onClick={(e) => toggleDropdown(e, 'aboutus')}
                >
                    <span>About Us</span>
                    {openDropdowns.aboutus ? <ArrowUp /> : <ArrowDown />}
                </a>
                {openDropdowns.aboutus && (
                    mobile ? (
                        <ul className="list-unstyled mx-3 fw-normal pb-1">
                            <li><Link className={`dropdown-item link-dark rounded p-1 my-1 ${splitLocation[1] === "AboutUs" ? "activeSub" : ""}`} to="/AboutUs">About Us</Link></li>
                            <li><Link className={`dropdown-item link-dark rounded p-1 my-1 ${splitLocation[1] === "PlanningArea" ? "activeSub" : ""}`} to="/PlanningArea">Planning Area</Link></li>
                            <li><Link className={`dropdown-item link-dark rounded p-1 my-1 ${splitLocation[1] === "PlanningGroup" ? "activeSub" : ""}`} to="/PlanningGroup">Planning Group Members</Link></li>
                            <li><Link className={`dropdown-item link-dark rounded p-1 my-1 ${splitLocation[1] === "CommitteeAssignments" ? "activeSub" : ""}`} to="/CommitteeAssignments">Committee Assignments</Link></li>
                        </ul>
                    ) : (
                        <div style={dropdownMenuStyle}>
                            <Link style={dropdownItemStyle(splitLocation[1] === "AboutUs")} to="/AboutUs">About Us</Link>
                            <Link style={dropdownItemStyle(splitLocation[1] === "PlanningArea")} to="/PlanningArea">Planning Area</Link>
                            <Link style={dropdownItemStyle(splitLocation[1] === "PlanningGroup")} to="/PlanningGroup">Planning Group Members</Link>
                            <Link style={dropdownItemStyle(splitLocation[1] === "CommitteeAssignments")} to="/CommitteeAssignments">Committee Assignments</Link>
                        </div>
                    )
                )}
            </li>
            <li
                className="nav-item mx-2 mb-1"
                style={{ position: 'relative' }}
                ref={refs.meetings}
            >
                <a
                    href="#"
                    className={`nav-link d-flex justify-content-between align-items-center gap-2 ${['Meetings', 'MeetingsArc'].includes(splitLocation[1]) ? "active" : ""}`}
                    onClick={(e) => toggleDropdown(e, 'meetings')}
                >
                    <span>Meetings</span>
                    {openDropdowns.meetings ? <ArrowUp /> : <ArrowDown />}
                </a>
                {openDropdowns.meetings && (
                    mobile ? (
                        <ul className="list-unstyled mx-3 fw-normal pb-1">
                            <li><Link className={`dropdown-item link-dark rounded p-1 my-1 ${splitLocation[1] === "Meetings" ? "activeSub" : ""}`} to="/Meetings">Meetings</Link></li>
                            <li><Link className={`dropdown-item link-dark rounded p-1 my-1 ${splitLocation[1] === "MeetingsArc" ? "activeSub" : ""}`} to="/MeetingsArc">Archive</Link></li>
                        </ul>
                    ) : (
                        <div style={dropdownMenuStyle}>
                            <Link style={dropdownItemStyle(splitLocation[1] === "Meetings")} to="/Meetings">Meetings</Link>
                            <Link style={dropdownItemStyle(splitLocation[1] === "MeetingsArc")} to="/MeetingsArc">Archive</Link>
                        </div>
                    )
                )}
            </li>
            <li className="nav-item mx-2 mb-1">
                <Link className={`nav-link ${splitLocation[1] === "Calendar" ? "active" : ""}`} to="/Calendar">
                    Calendar
                </Link>
            </li>
            <li
                className="nav-item mx-2 mb-1"
                style={{ position: 'relative' }}
                ref={refs.downloads}
            >
                <a
                    href="#"
                    className={`nav-link d-flex justify-content-between align-items-center gap-2 ${['Downloads', 'PlanningDocs'].includes(splitLocation[1]) ? "active" : ""}`}
                    onClick={(e) => toggleDropdown(e, 'downloads')}
                >
                    <span>Downloads</span>
                    {openDropdowns.downloads ? <ArrowUp /> : <ArrowDown />}
                </a>
                {openDropdowns.downloads && (
                    mobile ? (
                        <ul className="list-unstyled mx-3 fw-normal pb-1">
                            <li><Link className={`dropdown-item link-dark rounded p-1 my-1 ${splitLocation[1] === "Downloads" ? "activeSub" : ""}`} to="/Downloads">Downloads</Link></li>
                            <li><Link className={`dropdown-item link-dark rounded p-1 my-1 ${splitLocation[1] === "PlanningDocs" ? "activeSub" : ""}`} to="/PlanningDocs">Planning Documents</Link></li>
                        </ul>
                    ) : (
                        <div style={dropdownMenuStyle}>
                            <Link style={dropdownItemStyle(splitLocation[1] === "Downloads")} to="/Downloads">Downloads</Link>
                            <Link style={dropdownItemStyle(splitLocation[1] === "PlanningDocs")} to="/PlanningDocs">Planning Documents</Link>
                        </div>
                    )
                )}
            </li>
            <li className="nav-item mx-2 mb-1">
                <Link className={`nav-link ${splitLocation[1] === "Links" ? "active" : ""}`} to="/Links">
                    Links
                </Link>
            </li>
        </ul>
    )
}